import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";

import useGameAndVersion from "../shared/hooks/useGameAndVersion";
import { LoadingScreen } from "./components/LoadingScreen";

export default function DemoPlayer() {
  const { gameName, version } = useParams();

  const [loaded, setLoaded] = useState(false);
  const [module, setModule] = useState<any>();
  const containerRef = useRef<HTMLDivElement>(null);
  const mountedRef = useRef(false);

  const { gameVersion } = useGameAndVersion(gameName, version ?? null);

  // Load game module
  useEffect(() => {
    if (!gameVersion) {
      setModule(undefined);
      return;
    }

    import(/* @vite-ignore */ /* webpackIgnore: true */ gameVersion.webEntry)
      .then((mod: any) => {
        setModule(mod);
      })
      .catch((err: any) => {
        console.error("Failed to load demo module:", err);
      });
  }, [gameVersion]);

  // Mount the demo viewer
  useEffect(() => {
    if (!module || mountedRef.current) {
      return;
    }

    const container = containerRef.current;
    if (!container) {
      return;
    }

    mountedRef.current = true;
    container.style.display = "block";

    const loadTimeout = setTimeout(() => setLoaded(true), 250);

    module.createDemoMatchViewer(container, (totalPanels: number, panelsLoaded: number) => {
      clearTimeout(loadTimeout);
      setLoaded(totalPanels > 0 && totalPanels === panelsLoaded);
    });
  }, [module]);

  return (
    <>
      {!loaded && (
        <LoadingScreen
          backgroundColor={gameVersion?.backgroundColor}
          foregroundColor={gameVersion?.foregroundColor}
        />
      )}

      <div
        id="player"
        ref={containerRef}
        style={{
          display: "none",
          width: "100%",
          height: "100%",
        }}
      />
    </>
  );
}
